
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary, {
    AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';
import { SelectArrow } from './Icons/SelectArrow';
import { BodyTextM } from './Typography';


export const SelectArrowOrange = styled(SelectArrow)(({ theme }) => (
    theme.unstable_sx({
        color: theme.palette.primary.main,
        mx: theme.spacing(3),
    })
));

export const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: 0,
    width: '99%',
    margin: "0 auto",
    boxShadow: theme.customShadows.far,
    '&:not(:last-child)': {
        marginBottom: theme.spacing(5),
    },
    '&::before': {
        height: 0,
    },
}));

export const AccordionSummaryActionLabel = styled(BodyTextM)(({ theme }) => (
    theme.unstable_sx({
        color: theme.palette.primary.main,
    })
));

export const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<SelectArrowOrange />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(180deg)',
    },
    '& .MuiAccordionSummary-content': {
        display: 'flex',
        justifyContent: 'space-between',
    },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(0),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));


